import api from '@/apis/sf/voucherSearchAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('moduleVoucherSearch', api);

const state = {
  ...crud.state,
  _config: {
    table: 'search_field',
    field: {
      key: '',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
